'use client'

import { dispatchRouteChangeEvent } from '@/utils/routeEvents';
import { useRouter } from 'next/navigation';
import { ReactNode, ButtonHTMLAttributes } from 'react';

interface BackProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    children: ReactNode;
}

export default function Back({ children, ...props }: BackProps) {
    const router = useRouter()
    return (
        <button {...props} onClick={() => {
            dispatchRouteChangeEvent('start')
            router.back()}}>
            {children}
        </button>
    );
}